import React, { useContext } from 'react';
import { connect } from 'react-redux';

import BaseNode from '../BaseNode';
import { SchemaDisplayContext } from '../../context';
import { putPropsToEventHandler, shouldShowSocketIn } from '../../helpers/node';
import ConnectionSocketOut from '../ConnectionSocketOut';
import ConnectionSocketIn from '../ConnectionSocketIn';
import { EDIT_SCHEMA_MODE } from '../../../constants';
import EditTrigger from '../EditTrigger';
import DeleteTrigger from '../DeleteTrigger';
import UnchainMarker from '../UnchainMarker';
import { plazaIsActive } from '../../../../selectors';
import ViewTrigger from '../ViewTrigger';

const connectionOutProps = {
  x: 95,
  y: -19,
  width: 20,
  height: 20,
};

const connectionInProps = {
  x: 95,
  y: 41,
  width: 20,
  height: 20,
};

const backgroundProps = ({ color }) => ({
  x: 85,
  y: 1,
  width: 40,
  height: 40,
  fill: color,
});

const iconProps = ({ icon }) => ({
  x: 93,
  y: 9,
  height: 25,
  href: icon,
});

const hintProps = {
  x: 85,
  y: 1,
  width: 40,
  height: 40,
};

const controlsProps = {
  x: 130,
  y: -2,
  width: 20,
  height: 60,
};

function JunctionNode(props) {
  const {
    plaza: { locked },
    node: {
      isConnected, connectingSourceNode, click, mouseDown, mouseUp,
    },
    schema: { mode },
  } = useContext(SchemaDisplayContext);
  const {
    icon, color, title, plazaIsActive,
  } = props;

  const DnDEvents = !plazaIsActive || locked ? {} : {
    onClick: putPropsToEventHandler(click, props),
    onMouseDown: putPropsToEventHandler(mouseDown, props),
    onMouseUp: putPropsToEventHandler(mouseUp, props),
  };

  return (
    <BaseNode {...props}>
      {
        (mode === EDIT_SCHEMA_MODE && plazaIsActive && !locked) && (
          <foreignObject {...connectionOutProps}>
            <ConnectionSocketOut {...props} />
          </foreignObject>
        )
      }
      <rect {...backgroundProps({ color })} />
      <image {...iconProps({ icon })} />
      <foreignObject {...hintProps}>
        <div
          style={{ height: '100%' }}
          title={title}
          {...DnDEvents}
        />
      </foreignObject>
      {
        shouldShowSocketIn(connectingSourceNode, props, isConnected(props.id)) && (
          <foreignObject {...connectionInProps}>
            <ConnectionSocketIn {...props} />
          </foreignObject>
        )
      }
      {
        (plazaIsActive && mode === EDIT_SCHEMA_MODE) && (
          <foreignObject {...controlsProps}>
            {
              !locked && (
                <>
                  <EditTrigger {...props} />
                  <DeleteTrigger {...props} />
                  <UnchainMarker {...props} />
                </>
              )
            }
            {
              locked && (
                <ViewTrigger {...props} />
              )
            }
          </foreignObject>
        )
      }
    </BaseNode>
  );
}

const mapStateToProps = (state) => ({
  plazaIsActive: plazaIsActive(state),
});

export default connect(mapStateToProps)(JunctionNode);
